import { Regions } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function EditPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Regions", href: "/regions" },
          { title: "Edit Region", href: `/regions/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Region</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Regions.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
